declare var $:any;
import * as React from 'react';
import './MainStageQuestionsPage.pcss';
import {observer} from "mobx-react";
import {IPageWrapperWithNav_Props, PageWrapperWithNav} from "components/widgets/PageWrapperWithNav";
import {action, computed, observable} from "mobx";
import {MainStageData, MainStageEvent} from "data/MainStageData";
import {GET_QUERY, POST_QUERY} from "utils";





@observer
export class MainStageQuestionsPage extends React.Component<IPageWrapperWithNav_Props> {
  @observable adminLoginNeeded = false;

  @observable mainStageEvent:MainStageEvent|undefined;
  @observable questions:MainStageQuestion[] = [];
  @observable displayStatus:string = 'new';

  @observable statusMessage:string;
  @observable statusLevel:string;
  @observable disableStatusMessageButton:boolean = false;



  @computed get newQuestions() { return this.questions.filter((q)=>q.status==='new'); }
  @computed get savedQuestions() { return this.questions.filter((q)=>q.status==='saved'); }
  @computed get askedQuestions() { return this.questions.filter((q)=>q.status==='asked'); }
  @computed get hiddenQuestions() { return this.questions.filter((q)=>q.status==='hidden'); }
  @computed get showNew() { return this.displayStatus==='new'; }
  @computed get showSaved() { return this.displayStatus==='saved'; }
  @computed get showAsked() { return this.displayStatus==='asked'; }
  @computed get showHidden() { return this.displayStatus==='hidden'; }
  @computed get displayedQuestions() {
    if(this.showNew) {
      return this.newQuestions;
    } else if(this.showSaved) {
      return this.savedQuestions;
    } else if(this.showAsked) {
      return this.askedQuestions;
    }  else {
      return this.hiddenQuestions;
    }
  }

  constructor(props:IPageWrapperWithNav_Props) {
    super(props);
    this.setMainStageEvent(MainStageData.liveMainStageEvent);
    this.statusMessage = MainStageData.statusMessage;
    this.statusLevel = MainStageData.statusLevel;
  }

  setMainStageEvent = (mainStageEvent:MainStageEvent|undefined) => {
    this.mainStageEvent = mainStageEvent;
    this.loadQuestions();
  }

  @action
  loadQuestions = () => {
    this.questions = [];
    if(this.mainStageEvent) {

      const _questions: MainStageQuestion[] = [];
      //this.updateState = 'pending';
      $.ajax(GET_QUERY('/admin/mainStageEventQuestions/' + this.mainStageEvent._id))
        .done((questionResponse: any) => {
          questionResponse.forEach((json) => {
            _questions.push(new MainStageQuestion(json));
          });
          this.questions = observable(_questions);
          //this.update(statusUpdate)
          //this.updateState = 'updated';
        })
        .fail(action((err: any) => {
          console.log(err);
          this.adminLoginNeeded = true;
          // this.updateState = 'error';
        }));
    }
  }

  handleHideQuestion = (question:MainStageQuestion) => {
    this.updateStatus(question, 'hidden');
  }

  handleSaveQuestion = (question:MainStageQuestion) => {
    this.updateStatus(question, 'saved');
  }

  handleAskQuestion = (question:MainStageQuestion) => {
    this.updateStatus(question, 'asked');
  }

  updateStatus = (question:MainStageQuestion, status:string) => {
    if(this.mainStageEvent) {
      question.status = status;
      $.ajax(GET_QUERY('/admin/mainStageEventQuestions/updateStatus/' + question._id+'/'+status))
          .done(()=>{})
          .fail(action((err: any) => {
            console.log(err);
            this.adminLoginNeeded = true;
          }));
    }
  }

  updateStatusMessage = () => {
    this.disableStatusMessageButton = true;
    const data = {
      message:this.statusMessage,
      level:this.statusLevel,
    };
    $.ajax(POST_QUERY('/admin/mainStageStatusMessage', data ))
    .done((result:any) => {
      alert('Status message saved.');
      this.disableStatusMessageButton = false;
    })
    .fail(action((err: any) => {
      alert('Status message did not save!');
      this.disableStatusMessageButton = false;
      this.adminLoginNeeded = true;
    }));
  }

  render() {
    if(this.adminLoginNeeded) {
      return (
          <PageWrapperWithNav {...this.props} className={"mainstage-questions"}>
            <div style={{margin:'18px'}}>
              <h2>Not Authorized</h2>
              <p>Please open another tab in this same browser profile, and sign in as an admin.</p>
            </div>
          </PageWrapperWithNav>
      );
    }

    return (
      <PageWrapperWithNav {...this.props} className={"mainstage-questions"}>




        Event
        {MainStageData.mainStageEvents.map((mainStageEvent)=>{
          return (
            <React.Fragment key={mainStageEvent._id}>&nbsp;:: <a href="#" onClick={() => { this.setMainStageEvent(mainStageEvent); }}>{mainStageEvent.navTitle}</a></React.Fragment>
          );
        })}

        <div style={{margin:'16px 0px'}}>
          <div style={{display:'flex'}}>

            <textarea disabled={this.disableStatusMessageButton} style={{width:'50%', height:'36px'}} onChange={(e)=>{ this.statusMessage = e.target.value; }} value={this.statusMessage}></textarea>
            <div style={{marginLeft:'16px'}}>
              Canned messages:<br/>
              <a href={'#'} onClick={()=>{ this.statusMessage=''; this.statusLevel='normal'; }}>EMPTY</a>,&nbsp;
              <a href={'#'} onClick={()=>{ this.statusMessage='We are live now! If you can’t see the video, try refreshing your browser.'; this.statusLevel='normal'; }}>NORMAL</a>,&nbsp;
              <a href={'#'} onClick={()=>{ this.statusMessage='Hi everyone, we are experiencing technical difficulties with the live stream. Stay tuned for updates shortly!'; this.statusLevel='alert'; }}>STAY TUNED</a>,&nbsp;
              <a href={'#'} onClick={()=>{ this.statusMessage='We\'re going to be starting Q&A shortly! Submit your questions now.'; this.statusLevel='alert'; }}>QA STARTING</a>,&nbsp;
              <a href={'#'} onClick={()=>{ this.statusMessage='You can find this recipe in our resource library.'; this.statusLevel='alert'; }}>RECIPE</a>,&nbsp;
              <a href={'#'} onClick={()=>{ this.statusMessage='Thank you for joining us!'; this.statusLevel='normal'; }}>THANKS</a>,&nbsp;
            </div>
          </div>
          <div>
            <input disabled={this.disableStatusMessageButton} type={"radio"} value={'normal'} name={'statusLevel'} checked={this.statusLevel==='normal'} onClick={()=>{ this.statusLevel = 'normal'; }}  /> Normal
            &nbsp;
            <input disabled={this.disableStatusMessageButton} type={"radio"} value={'alert'} name={'statusLevel'}  checked={this.statusLevel==='alert'} onClick={()=>{ this.statusLevel = 'alert'; }} /> Alert
          </div>
          <div><button disabled={this.disableStatusMessageButton} onClick={this.updateStatusMessage}>Update Status Message</button></div>
        </div>

        {this.mainStageEvent &&
        <React.Fragment>
          <hr/>
          <a href="#" onClick={this.loadQuestions}>reload</a> ::&nbsp;
          <a href="#" onClick={() => { this.displayStatus = 'new'; }}>new ({this.newQuestions.length})</a> ::&nbsp;
          <a href="#" onClick={() => { this.displayStatus = 'hidden'; }}>hidden ({this.hiddenQuestions.length})</a> ::&nbsp;
          <a href="#" onClick={() => { this.displayStatus = 'saved'; }}>saved ({this.savedQuestions.length})</a> ::&nbsp;
          <a href="#" onClick={() => { this.displayStatus = 'asked'; }}>asked ({this.askedQuestions.length})</a>
          <hr/>
          <h2>{this.displayedQuestions.length} {this.displayStatus} Questions for {this.mainStageEvent.navTitle}</h2>
          <table className={"questions"}><tbody>
          {this.displayedQuestions.map((question) => <Question key={question._id} question={question}
                                                                             onAsk={this.handleAskQuestion}
                                                                             onHide={this.handleHideQuestion}
                                                                             onSave={this.handleSaveQuestion}/>)}
          </tbody></table>
        </React.Fragment>
        }
      </PageWrapperWithNav>
    );
  }
}

interface IQuestionProps {
  question:MainStageQuestion;
  onHide:(question:MainStageQuestion)=>void;
  onSave:(question:MainStageQuestion)=>void;
  onAsk:(question:MainStageQuestion)=>void;
}
@observer
class Question extends React.Component<IQuestionProps> {
  handleAsk = () => { this.props.onAsk(this.props.question); }
  handleHide = () => { this.props.onHide(this.props.question); }
  handleSave = () => { this.props.onSave(this.props.question); }
  render() {
    return (
      <tr>
        <td><a href={"#"} onClick={this.handleHide}>hide</a></td>
        <td><a href={"#"} onClick={this.handleSave}>save</a></td>
        <td><a href={"#"} onClick={this.handleAsk}>ask</a></td>
        <td>{this.props.question.userName}</td>
        <td>{this.props.question.userNickname}</td>
        <td>{this.props.question.question}</td>
      </tr>
    );
  }
}

class MainStageQuestion {
  _id:string;
  userName:string;
  userNickname:string;
  question:string;
  dateCreated:Date;
  @observable status:string; // new, hidden, saved, asked
  constructor(json:any) {
    this._id = json._id;
    this.userName = json.userName;
    this.userNickname = json.userNickname;
    this.question = json.question;
    this.dateCreated = json.dateCreated;
    this.status = json.status;
  }
}
